import { BaseError } from '@dynamic-labs-sdk/client';

export class TransactionRequiredError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'transaction_required_error',
      docsUrl: null,
      name: 'TransactionRequiredError',
      shortMessage: 'No transaction specified for broadcast',
    });
  }
}
